<template>
  <div>
    <!-- REPORT_TEMPLATE.广东省人民医院珠海医院呼吸科 -->
    <div v-if="model.reportTemplateType == 14 || model.reportTemplateType == 30" class="title" style="display: block">
      <div class="title-content-pic">
        <img v-if="model.reportTemplateType == 14" class="title-content-pic-pic" :src="model.hospitalIcon" />
        <img v-if="model.reportTemplateType == 30" class="title-content-pic-pic-30" :src="model.hospitalIcon" />
        <p class="title-content-pic-subtitle">{{ model.reportSubtitle }}</p>
      </div>
      <div class="title-buttons">
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onShareClick">
          分享
        </button>
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onDownloadPDFClick">
          下载PDF
        </button>
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onDownloadPNGClick">
          下载PNG
        </button>
        <button class="title-buttons-item right noPrint" data-html2canvas-ignore="true" @click="onPrintClick">
          打印
        </button>
      </div>
    </div>
    <div v-else class="title" :class="{'title-height-100': model.reportTemplateType == 50}">
      <div class="title-content-normal">
        <template v-if="isGuangzhouJihua">
          <div class="title-content-normal-jihua">
            <img class="title-content-normal-jihua-icon" :src="guangzhouJihuaLogo" alt="暨华医院" />
            <p class="title-content-normal-jihua-subtitle">{{ model.reportSubtitle }}</p>
          </div>
        </template>
        <template v-else>
          <div class="title-content-normal-left">
            <img class="title-content-normal-left-icon" :src="model.hospitalIcon" alt="" />
          </div>
          <div class="title-content-normal-middle">
            <p class="title-content-normal-middle-title" v-for="(item, index) in model.reportTitleArray" :key="index">
              {{ item }}
            </p>
            <p :class="[
              model.reportTitleArray
                ? 'title-content-normal-middle-subtitle'
                : 'title-content-normal-middle-title',
            ]">
              {{ model.reportSubtitle }}
            </p>
            <!-- REPORT_TEMPLATE.上海市第一人民医院酒泉医院 -->
            <p v-if="model.reportTemplateType == 17" class="title-content-normal-middle-subtitle-2">
              睡眠呼吸报告
            </p>
          </div>
        </template>
      </div>
      <div class="title-buttons">
        <button v-if="showSaveButton" class="title-buttons-item noPrint" data-html2canvas-ignore="true"
          @click="onSaveClick">
          保存
        </button>
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onShareClick">
          分享
        </button>
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onDownloadPDFClick">
          下载PDF
        </button>
        <button v-if="model.hospitalId == 1827" class="title-buttons-item title-buttons-item-wide noPrint"
          data-html2canvas-ignore="true" @click="onDownloadPatientPDFClick">
          下载患者版pdf
        </button>
        <button class="title-buttons-item noPrint" data-html2canvas-ignore="true" @click="onDownloadPNGClick">
          下载PNG
        </button>
        <button class="title-buttons-item right noPrint" data-html2canvas-ignore="true" @click="onPrintClick">
          打印
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: Object,
  },

  computed: {
    isGuangzhouJihua() {
      return this.model.reportTemplateType === REPORT_TEMPLATE.广州暨华;
    },

    showSaveButton() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.广州暨华:
        case REPORT_TEMPLATE.东莞市松山湖中心医院:
        case REPORT_TEMPLATE.襄阳市中心医院神经内科睡眠中心:
          return true;
        default:
          return false;
      }
    },
  },

  data() {
    return {
      icon: require("@imgs/main-weak-password-alert.png"),
      guangzhouJihuaLogo: require("@imgs/file-read-11939.png"),
    };
  },

  methods: {
    onDownloadPDFClick() {
      this.$emit("onDownloadPDFClick");
    },
    onDownloadPatientPDFClick() {
      this.$emit("onDownloadPatientPDFClick");
    },
    onDownloadPNGClick() {
      this.$emit("onDownloadPNGClick");
    },
    onPrintClick() {
      this.$emit("onPrintClick");
    },
    onShareClick() {
      this.$emit("onShareClick");
    },
    onSaveClick() {
      this.$emit("onSaveClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: rem(120);
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: rem(10);

  &-content-pic {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 110px;
    justify-content: center;

    &-pic {
      height: 35px;
      margin-bottom: 10px;
    }

    &-pic-30 {
      height: 87px;
      width: 450px;
    }

    &-subtitle {
      font-size: rem(18);
      line-height: rem(24);
    }
  }

  &-content-normal {
    width: 100%;

    &-left {
      width: rem(135);
      position: absolute;
      left: 0;

      &-icon {
        height: rem(70);
      }
    }

    &-middle {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      &-title {
        font-size: rem(24);
        font-weight: bold;
        line-height: rem(32);
      }

      &-subtitle {
        font-size: rem(18);
        line-height: rem(32);
      }

      &-subtitle-2 {
        font-size: rem(16);
        line-height: rem(24);
      }
    }

    &-jihua {
      width: 100%;
      height: rem(95);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-icon {
        width: rem(155);
        height: auto;
        display: block;
      }

      &-subtitle {
        font-size: rem(18);
        font-weight: bold;
        line-height: rem(30);
      }
    }
  }

  &-buttons {
    align-self: flex-end;
    display: flex;
    position: absolute;
    right: 0;

    &-item {
      color: white;
      background-color: #169bd5;
      font-size: rem(12);
      border-radius: rem(4);
      width: rem(58);
      height: rem(25);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: rem(8);
    }

    &-item-wide {
      width: auto;
      padding: 0 rem(8);
    }
  }
}

.title-height-100 {
  height: rem(100);
}

@media print {
  .noPrint {
    display: none;
    background-color: white !important;
  }
}
</style>
